import store from './store'
import Home from './views/Home.vue'
const Works = () => import(/* webpackChunkName: "works" */ './views/Works.vue');
const Work = () => import(/* webpackChunkName: "work" */ './views/Work.vue');
const Contact = () => import(/* webpackChunkName: "contact" */ './views/Contact.vue');
const NotFound = () => import(/* webpackChunkName: "not-found" */ './views/NotFound.vue');

export const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
  },
  {
    path: '/works',
    name: 'works',
    component: Works,
  },
  {
    path: '/works/:slug',
    name: 'work',
    component: Work
  },
  { path: '*', component: NotFound }
];